import React, { useState, useRef, useEffect } from "react";

const AVATAR_COLORS = ["#7C4DFF", "#00B8D9", "#36B37E", "#FF8B00", "#FF5630", "#0052CC", "#6554C0", "#00875A"];

const getInitials = (name = "") => {
    const parts = name.trim().split(/\s+/).filter(Boolean);
    if (parts.length === 0) return "?";
    if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
    return (parts[0][0] + parts[1][0]).toUpperCase();
};

const getAvatarColor = (key = "") => {
    let hash = 0;
    for (let i = 0; i < key.length; i++) hash = key.charCodeAt(i) + ((hash << 5) - hash);
    return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length];
};

const UserMasterWorklistRow = ({
    item,
    rowIndex,
    isAdmin,
    menuRights,
    handleView,
    handleEdit,
    handleResetPassword,
}) => {
    const canOpenMenu = menuRights?.canEdit === true && item?.systemDefault !== true;
    const rowClass = rowIndex % 2 === 0 ? "row-even" : "row-odd";

    const [menuOpen, setMenuOpen] = useState(false);
    const menuRef = useRef(null);

    useEffect(() => {
        if (!menuOpen) return undefined;

        const handleOutsideClick = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setMenuOpen(false);
            }
        };
        const handleEscape = (event) => {
            if (event.key === "Escape") setMenuOpen(false);
        };

        document.addEventListener("mousedown", handleOutsideClick);
        document.addEventListener("keydown", handleEscape);
        return () => {
            document.removeEventListener("mousedown", handleOutsideClick);
            document.removeEventListener("keydown", handleEscape);
        };
    }, [menuOpen]);

    const handleRowClick = (event) => {
        if (event.target.closest(".open-cell")) return;
        if (menuRights?.canView === true) handleView(item);
    };

    const toggleMenu = (event) => {
        event.stopPropagation();
        setMenuOpen((prev) => !prev);
    };

    const onEditClick = (event) => {
        event.stopPropagation();
        setMenuOpen(false);
        handleEdit(item);
    };

    const onResetClick = (event) => {
        event.stopPropagation();
        setMenuOpen(false);
        handleResetPassword(item);
    };

    return (
        <div className={`card mt-0 quote-project-row user-project-row ${rowClass}`}>
            <div className="card-body">
                <div
                    className="quote-project-grid user-project-grid"
                    onClick={handleRowClick}
                    style={{ cursor: menuRights?.canView === true ? "pointer" : "default" }}
                >
                    <div className="project-cell">
                        <span className="avatar" style={{ backgroundColor: getAvatarColor(item?.FullName) }}>
                            {getInitials(item?.FullName)}
                        </span>
                        <div className="project-copy">
                            <h4>{item?.FullName}</h4>
                            <span>{item?.userName}</span>
                        </div>
                    </div>

                    <div className="company-cell">{item?.companyName || "-"}</div>
                    <div className="type-cell">{item?.userTypeName}</div>
                    <div className="role-cell">{item?.userRoleName}</div>

                    <div className="status-cell">
                        <span className={`user-status-pill ${item?.isActive ? "active" : "inactive"}`}>
                            {item?.isActive ? "Active" : "Inactive"}
                        </span>
                    </div>

                    <div className="open-cell">
                        {canOpenMenu && (
                            <div className={`dropdown dropleft text-align ${menuOpen ? "show" : ""}`} ref={menuRef}>
                                <i
                                    className="fas fa-ellipsis-v"
                                    id={`dropdownMenuButton-${item?.id}`}
                                    aria-haspopup="true"
                                    aria-expanded={menuOpen}
                                    onClick={toggleMenu}
                                ></i>
                                <div
                                    className={`dropdown-menu p-0 ${menuOpen ? "show" : ""}`}
                                    aria-labelledby={`dropdownMenuButton-${item?.id}`}
                                >
                                    <ul>
                                        <li onClick={onEditClick} style={{ cursor: "pointer" }}>
                                            <span>
                                                <i className="far fa-edit"></i> Edit
                                            </span>
                                        </li>
                                        {isAdmin && (
                                            <li onClick={onResetClick} style={{ cursor: "pointer" }}>
                                                <span>
                                                    <i className="fas fa-key"></i> Reset Password
                                                </span>
                                            </li>
                                        )}
                                    </ul>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default React.memo(UserMasterWorklistRow);